import React from "react";
import { connect } from "react-redux";
import { any, func } from "prop-types";
import moment from "moment";
import history from "../../history";
import FormCreatorV2 from "../../common/FormCreatorV2";
import { postCompleatFoodForm } from "../../redux/actions/index";
import {
  formCreatorConvertToValues,
  getField,
  useForm,
} from "../../common/FormCreator/helpers";

const PersonalDataConsentForm = ({ appData, postForm }) => {
  const initialData = {
    name: `${appData.firstName} ${appData.lastName}`,
    giveConsent: "",
    signature: `${appData.firstName} ${appData.lastName}`,
    date: moment().format("DD/MM/YYYY"),
  };
  const getVal = getField(initialData);

  const initialState = {
    blurb1: {
      htmlObj: (
        <div>
          <p>
            <strong>Why is personal data used?</strong>
          </p>
          <p>
            The Compleat Food Group needs to keep and process personal
            information about you for administrative, legal and management
            purposes.
          </p>
          <p>
            We will keep and use personal data to enable us to manage our
            relationship with you effectively, lawfully and appropriately,
            starting with the recruitment process, during your employment with
            The Compleat Food Group, at the time when your employment ends and
            after you have left.
          </p>
          <p>
            We use information to enable the performance of the employment
            contract, to comply with any legal requirements, and to protect our
            legal position in the event of legal proceedings.{" "}
          </p>
          <p>
            If you do not provide specific personal data inherent for the
            employment contract to operate, we may be unable in some
            circumstances to comply with our obligations and will require
            further discussions with yourself.
          </p>
          <p>
            <strong>What personal data is stored / processed and why?</strong>
          </p>
          <p>
            Personal information will be stored and processed to manage our
            employment relationship with you for the following purposes:
          </p>
          <p>
            <strong>Pay and contractual benefits</strong> - bank details and
            national insurance number are used in order to make salary/wage
            payments, pension deductions, and pay tax and national insurance
            contributions.
          </p>
          <p>
            <strong>Managing the employment relationship</strong> - we store
            such information as your application form and references, your
            contract of employment/offer letter and any amendments to it;
            correspondence with or about you, for example letters to you about a
            pay rise or, at your request, a letter to your mortgage or letting
            company confirming your salary; information needed for payroll,
            benefits and expenses purposes; contact and emergency contact
            details; records of holiday, sickness and other absence; information
            needed for equal opportunities monitoring policy; and records
            relating to your career history, such as training records,
            appraisals, other performance measures and, where appropriate,
            disciplinary and grievance records.
          </p>
          <p>
            <strong>Processing employment claims</strong> - personal details and
            information pertaining to grievances, absence and occupational
            health records are used to administrate personal injury and
            compensation claims.
          </p>
          <p>
            <strong>Pensions, health care and death in service</strong> - we
            collect and use your personal information so that we can administer
            benefits such as these.
          </p>
          <p>
            <strong>Health & Safety related information</strong> - where
            applicable we may keep information related to your health which
            could include reasons for absence, GP reports and notes. This
            information will be used in order to comply with our health & safety
            and occupational health obligations in order to consider how your
            health may affect your ability to do your role and how your role may
            affect your health and also whether any adjustments to your role
            might be appropriate. We will also need this data to administer and
            manage statutory and company sick pay.
          </p>
          <p>
            <strong>Ethnicity and disability information</strong> - equal
            opportunities reporting is monitored across our workforce to ensure
            our policies and procedures are appropriate for everyone.
          </p>
          <p>
            <strong>Emergency contact information</strong> - in the event of an
            emergency your emergency contact may be contacted if the situation
            requires it.
          </p>
          <p>
            <strong>NB.</strong> Please note if in the future we intend to
            process your personal data for a purpose other than that which it
            was collected we will provide you with information on that purpose
            and any other relevant information.
          </p>
          <p>
            <strong>Who will have access to personal data?</strong>
          </p>
          <p>
            HR, Occupational Health, Payroll and Health & Safety personnel have
            access to information about you to enable them to manage the needs
            of the business and provide specialist support to management.
          </p>
          <p>
            Your line manager may hold local records on performance, notes of
            one to one interviews etc. and also general job related information,
            relevant health & safety information, current pay, absence history
            and disciplinary history for example.
          </p>
          <p>
            We share your personal information with external third party service
            providers who manage services on behalf of The Compleat Food Group
            under service provision contracts such as:
          </p>
          <ul>
            <li>HR/Payroll processing</li>
            <li>Recruitment</li>
            <li>Pension & Insurance Companies</li>
          </ul>
          <p>
            We will only disclose information about you to third parties if we
            are legally obliged to do so or where we need to comply with our
            contractual duties or duty of care.
          </p>
          <p>
            <strong>NB.</strong> For further information regarding your rights
            please see your HR department.
          </p>
          <hr />
          <p>
            I have read and understood the contents of this document and{" "}
            <strong>consent / do not consent*</strong> for my personal data to
            be stored / processed as highlighted. I understand that I can
            request, at any time, for my consent to be withdrawn.
          </p>
          <i>*please indicate below as appropriate</i>
        </div>
      ),
    },
    giveConsent: {
      key: "giveConsent",
      value: getVal("giveConsent"),
      type: "checkbox",
      checkboxText1: "CONSENT",
      checkboxText2: "DO NOT CONSENT",
      mandatory: true,
    },
    name: {
      title: "Name",
      value: getVal("name"),
      mandatory: true,
      disabled: true,
    },

    signature: {
      title: "Signed",
      value: getVal("signature"),
      mandatory: true,
      disabled: true,
    },
    date: {
      title: "Date",
      value: getVal("date"),
      mandatory: true,
      disabled: true,
    },
  };
  const [fields, setField] = useForm(initialState);
  const submitted =
    appData.compleatFoodOnboarding && appData.compleatFoodOnboarding.YCF5;

  const redirectBack = () => {
    history.push("/profile/edit/compleat-food-onboarding");
  };

  const handleSubmit = () => {
    const fieldValuesPayload = formCreatorConvertToValues(fields);
    postForm("YCF5", {
      ...fieldValuesPayload,
    });
    redirectBack();
  };

  return (
    <>
      {submitted ? (
        redirectBack()
      ) : (
        <FormCreatorV2
          formTitle={"Employee Personal Data Consent Form"}
          fields={fields}
          setField={setField}
          handleCancel={() => redirectBack()}
          onboardingBranch={"molecular"}
          useSubmitText={true}
          handleSubmit={handleSubmit}
        />
      )}
    </>
  );
};

PersonalDataConsentForm.propTypes = {
  appData: any,
  postForm: func,
};

const mapDispatchToProps = {
  postForm: postCompleatFoodForm,
};
const mapStateToProps = (state) => ({
  appData: state.core.app,
});

const withRedux = connect(mapStateToProps, mapDispatchToProps);

export default withRedux(PersonalDataConsentForm);
